import { ReactComponentManifest } from "web/entrypoints/common/setup";
import PartnersPage from "web/react/pages/partners/partners-page";

const components: ReactComponentManifest = {
    PartnersPage,
};

export default components;
